export const EXPRESS_SHIP_RATE = 2.0;
export const SAVE_SHIP_RATE = 7;
export const BOOK_SAVE_SHIP_RATE = 5;
